import styled from "styled-components";

export const Container = styled.header`
    height: 60px;
    padding: 0 40px;
    display: flex;
    justify-content: center;

    @media(min-width:768px) {
        justify-content: start;
    }

    > a {
        height: 100%;
        font-size: 1rem;
        display: flex;
        align-items: center;

        @media(min-width:480px) {
            font-size: 1.5rem;
            line-height: 29.8px;
        }

        @media(min-width:768px) {
            font-size: 0.875rem;
            padding: 0 24px;
            line-height: 15px;
        }
    }

    .logo{
        height: 20px;

        @media(min-width:768px) {
            height: 25px;
        }
    }
 
`